import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/executive';

const fetchExecutive = createAction('fetchExecutive');

function fetchExecutiveSuccess(state, action) {
  state.successFetching = true;
  state.errorFetching = false;
  state.executive = { ...action.payload };
}

function fetchExecutiveError(state) {
  state.successFetching = false;
  state.errorFetching = true;
  state.executive = null;
}

const executiveReducer = createSlice({
  name: 'executive',
  initialState,
  reducers: {
    fetchExecutiveSuccess,
    fetchExecutiveError,
  },
});

export const executiveActions = {
  ...executiveReducer.actions,
  fetchExecutive,
};

export default executiveReducer.reducer;
